import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuditListComponent } from './audit-list.component';
import {
  MatInputModule,
  MatPaginatorModule,
  MatProgressSpinnerModule,
  MatSnackBarModule,
  MatSortModule,
  MatTableModule,
  MatTabsModule,
  MatTooltipModule
} from '@angular/material';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { ScrollbarModule } from '../../../core/scrollbar/scrollbar.module';
import { ListModule } from '../../../core/list/list.module';
import { PageHeaderModule } from '../../../core/page-header/page-header.module';
import { BreadcrumbsModule } from '../../../core/breadcrumbs/breadcrumbs.module';
import { DeleteDialogModule } from '../../../core/dialogs/deleted-dialog/delete-dialog.module';
import { CreateAuditDialogModule } from '../../../core/dialogs/create-audit-dialog/create-audit-dialog.module';
import { ExportAuditDialogModule } from '../../../core/dialogs/export-audit-dialog/export-audit-dialog.module';

import { CopyDialogModule } from '../../../core/dialogs/copy-dialog/copy-dialog.module';
import { PreviewAuditDialogModule } from '../../../core/dialogs/preview-audit-dialog/preview-audit-dialog.module';
import { PreviewAuditPictureDialogModule } from '../../../core/dialogs/preview-audit-picture-dialog/preview-audit-picture-dialog.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    FlexLayoutModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatTabsModule,
    ScrollbarModule,
    MatSnackBarModule,
    MatTooltipModule,

    // Core
    ListModule,
    PageHeaderModule,
    BreadcrumbsModule,
    DeleteDialogModule,
    CreateAuditDialogModule,
    ExportAuditDialogModule,
    CopyDialogModule,
    PreviewAuditDialogModule,
    PreviewAuditPictureDialogModule,
  ],
  declarations: [AuditListComponent],
  exports: [AuditListComponent]
})
export class AuditListModule { }



// WEBPACK FOOTER //
// /home/web_clients/qualicheck.fr/preprod/erp/src/app/pages/audits/audit-list/audit-list.module.ts